import { CongressesService } from "@/client";
import { useQuery } from "@tanstack/react-query";

const migrationLogsQueryKey = (congressId: string) => {
  return ["migration-logs", congressId] as const;
};

function useMigrationLogs(congressId: string) {
  return useQuery({
    queryKey: migrationLogsQueryKey(congressId),
    queryFn: () => CongressesService.getMigrationLogs({ congressId }),
  });
}

export { migrationLogsQueryKey, useMigrationLogs };
